import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './css/font/font.css'
import './css/iconfont/iconfont.css'


Vue.config.productionTip = false
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
Vue.use(Antd)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
